export default {
  name: "WineDiscountPricePostedDraftPopover"
};